import React from 'react'
import _ from 'lodash'
import immutable from 'immutable'

import {RelatedActivity} from '../widgets/relatedcontentband/relatedactivity.component'

export class ActivitySearchItem extends React.Component {
    constructor(props) {
        super(props)

        this._activity = new immutable.fromJS(this.props.activity)

        _.bindAll(this,
            'addToItin',
            'removeFromItin',
            'activityContainsAny',
            'showDetails'
        )
    }

    componentDidMount() {
        // this.props.updateActiveItems(1)
    }

    addToItin() {
        this.props.onSelectActivity(this.props.leg, this._activity, this.props.user)
    }

    removeFromItin() {
        this.props.onRemoveActivity(this.props.leg, this._activity, this.props.user)
    }

    showDetails() {
        this.props.activateSearchItem(this._activity)
    }

    activityContainsAny() {
        if (this.props.activeFilters.length > 0) {
            // filter on
            let keywords = this._activity.getIn(['types']) || this._activity.getIn(['keywords'])
            let result = keywords.some(function (item) {
                return this.props.availableFilters[this.props.activeFilters].indexOf(item) >= 0
            }, this)
            if (result) {
                this.props.updateActiveItems(1) // increment parent container
            } else {
                this.props.updateActiveItems(0) // no increment, but we still want to call to trigger secondary search
            }
            return result
        } else {
            // show all
            this.props.updateActiveItems(1)
            return true
        }
    }

    render() {
        let showClass = this.activityContainsAny() ? 'show' : 'hide'

        return <RelatedActivity
            {...this.props}
            item={ this._activity }
            className={showClass}
            availableFilters={ this.props.availableFilters }
            showDetails={ this.showDetails }
            addToItin={this.addToItin}
            removeFromItin={ this.removeFromItin }/>
    }
}
